package org.example.zone360.models

import kotlinx.serialization.Serializable

@Serializable
data class DeleteClubTeamResponse(
    val data: String? = null,
    val team_id: String? = null,
    val error: String? = null

)

